import { message } from "antd";
import { useMutation } from "@tanstack/react-query";
import { SendOtp, ResetPassword } from "../../Api";
import { ROUTE } from "../../Constant";

interface UseForgotPasswordMutationProps {
  email: string;
  otp: string;
  password: string;
  setStep: React.Dispatch<React.SetStateAction<1 | 2>>;
  navigate: (path: string) => void;
}

export const useForgotPasswordMutation = ({
  email,
  otp,
  password,
  setStep,
  navigate,
}: UseForgotPasswordMutationProps) => {
  const sendOtpMutation = useMutation({
    mutationFn: async (emailAddress: string) => {
      return await SendOtp(emailAddress);
    },
    onSuccess: (res) => {
      if (res.success) {
        message.success(res.message);
        setStep(2);
      } else {
        message.error(res.message);
      }
    },
    onError: (err: any) => {
      message.error(err?.message || "Failed to send OTP.");
    },
  });

  const resetPasswordMutation = useMutation({
    mutationFn: async () => {
      return await ResetPassword({
        email,
        otp,
        password,
      });
    },
    onSuccess: (res) => {
      if (res.success) {
        message.success(res.message);
        navigate(ROUTE.login);
      } else {
        message.error(res.message);
      }
    },
    onError: (err: any) => {
      message.error(err?.message || "Failed to reset password.");
    },
  });

  return {
    sendOtpMutation,
    resetPasswordMutation,
  };
};
